<template>
  <div>
    <span>
      <b-button v-on:click="addInfo()" size="sm" variant="outline-light">
        <Icon
          :icon="params.addIcon"
          width="20"
          height="20"
          v-b-tooltip.hover.bottom="$t('Detail')"
          :color="params.iconColor"
        />
      </b-button>
    </span>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
export default {
  props: ["addMethods", "addIcon", "iconColor"],
  components: { Icon },
  methods: {
    addInfo() { 
      this.$root.$emit(this.params.addMethods, this.params.data);
    },
  },
};
</script>
